module.exports = __webpack_public_path__ + "static/bundle-individual-954399f795be4d0d2de0a9e39048894d.png";